"use client";

import { HeroButton } from "@/ui/HeroButton/HeroButton";
import { navLinks } from "@/data/constants";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Link from "next/link";
// import { useRouter } from "next/navigation";
import Cookies from "js-cookie";
import { useMobileNavActions } from "@/lib/useMobileNavActions/useMobileNavActions";
import { NewHeaderLogo } from "@/ui/NewHeaderLogo/NewHeaderLogo";
import { usePathname } from "next/navigation";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import { jwtDecode } from "jwt-decode";
// import { AiIframe } from "@/ui/AiChat/AiIframe";
import LinuxIcon from "@/ui/icon/LinuxIcon";
import IframeComponent from "@/ui/AiChat/IframeComponent";
import { useIframe } from "@/ui/AiChat/useIframe";
import { UserIcon } from "@/components/svg";

interface HeaderProps {
  hasCryptoMarquee?: boolean;
}
interface MyTokenPayload {
  token: string;
  sub: string;
  iat: number;
  exp: number;
  user: {
    email: string;
    roles: string[];
  };
}
const Header: React.FC<HeaderProps> = ({ hasCryptoMarquee = true }) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const dropdownOpenRef = useRef(dropdownOpen);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const baseUrl = useRef<null | string>(null);
  const [showLoginBox, setShowLoginBox] = useState(false);
  const [decodedToken, setDecodedToken] = useState<MyTokenPayload | null>(null);
  const [deviceOS, setDeviceOS] = useState<"android" | "ios" | "other">(
    "other"
  );

  useEffect(() => {
    baseUrl.current = window.location.protocol + "//" + window.location.host;
  }, []);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
      setDeviceOS("android");
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      setDeviceOS("ios");
    } else {
      setDeviceOS("other");
    }
  }, []);

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const { toggleOffcanvas } = useMobileNavActions();
  const pathname = usePathname();

  useEffect(() => {
    dropdownOpenRef.current = dropdownOpen;
  }, [dropdownOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        dropdownOpenRef.current
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const getCookie = (name: string) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop()?.split(";").shift();
      return null;
    };

    const token = getCookie("token");
    setIsLoggedIn(!!token);

    // Get user email from cookie if available
   
  }, []);

  const isPageFixed = useMemo(() => {
    return (
      pathname.includes("crypto-market") ||
      pathname.includes("nft") ||
      pathname.includes("watchlist") ||
      pathname.includes("exchanges") ||
      pathname.includes("portfolio")
    );
  }, [pathname]);

  const handleUserClick = async () => {
    try {
      const token = Cookies.get("auth_token")
        ? Cookies.get("auth_token")
        : Cookies.get("token");

      if (token) {
        setShowLoginBox(!showLoginBox);
        const decoded = jwtDecode<MyTokenPayload>(token);
        setDecodedToken(decoded);
      } else {
        if (!baseUrl.current) {
          baseUrl.current =
            window.location.protocol + "//" + window.location.host;
        }

        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BASE_URL}CentralAuthentication/GetAccessToken`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              RedirectUrlOnSuccess: baseUrl.current + "/api/set-token",
              RedirectUrlOnFail: baseUrl.current + "/",
            }),
          }
        );

        const data = await response.json();
        if (data && "result" in data) {
          window.location.href = data.result.redirectUrl;
        }
      }
    } catch (error) {
      console.error("Error in handleUserClick:", error);
    }
  };

  const { handleClick, showIframe } = useIframe();

  return (
    <>
      <div
        className={`${
          isPageFixed ? (showIframe ? "fixed" : "block") : "fixed"
        } z-40 left-0 top-0 header right-0 h-[90px]  ${
          hasCryptoMarquee ? "translate-y-10" : "translate-y-0"
        } sm:h-[126px] bg-gradient-to-b  to-transparent transition-all duration-300 px-2 md:px-6`}
      >
        <header
          className={`md:container xl:max-w-[1600px] 3xl:max-w-[1500px] justify-between  mx-auto h-full flex items-center px-2 lg:px-2 xl:px-[2vw] 2xl:px-0`}
          // className={`container justify-between  mx-auto h-full flex items-center`}
        >
          <Link href="/">
            <div className="flex items-center gap-3 sm:w-[240px]">
              <NewHeaderLogo />
              <span className="sr-only">Home</span>{" "}
              {/* This will be read by screen readers but hidden visually */}
            </div>
          </Link>
          <nav className="grow flex items-center ">
            {/* <ul className='items-center mx-auto border border-hero-slate-400 h-[57px] rounded-full px-3 hidden xl:flex text-sm backdrop-blur-md min-w-[773px] min-h-[57px]'> */}
            <ul className="items-center mx-auto border border-hero-slate-400 h-[57px] rounded-full px-3 hidden xl:flex text-sm backdrop-blur-md min-h-[57px]">
              {/* AI Chat Item */}
              <li
                onClick={handleClick}
                className="h-full flex flex-col items-center justify-center px-4 cursor-pointer transition-colors duration-200 group"
              >
                <p className="translate-y-[10px] font-jakarta group-hover:-translate-y-10 opacity-100 group-hover:opacity-0 transition-all duration-500 group-hover:rotate-x group-hover:scale-75">
                  AI Search
                </p>
                <p className="translate-y-10 opacity-0 group-hover:opacity-100 group-hover:-translate-y-[10px] transition-all duration-300 text-sky-200 scale-75 group-hover:scale-100">
                  AI Search
                </p>
              </li>

              {/* Other nav items */}
              {navLinks.map((item, idx) => (
                <li
                  key={idx}
                  className={`h-full flex flex-col items-center justify-center px-4 cursor-pointer transition-colors duration-200 ${
                    item?.txt == "Download Browser"
                      ? "block 2xl:hidden"
                      : "overflow-hidden"
                  } group relative`}
                >
                  <Link
                    target={item.newTab ? "_blank" : "_self"}
                    href={item.path}
                    className={
                      pathname.includes(item.path)
                        ? "header-text-color-active"
                        : ""
                    }
                  >
                    <p className="translate-y-[10px] font-jakarta group-hover:-translate-y-10 opacity-100 group-hover:opacity-0 transition-all duration-500 group-hover:rotate-x group-hover:scale-75">
                      {item.txt}
                    </p>
                    <p className="translate-y-10 opacity-0 group-hover:opacity-100 group-hover:-translate-y-[10px] transition-all duration-300 text-sky-200 scale-75 group-hover:scale-100">
                      {item.txt}
                    </p>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="flex lg:items-center gap-2 mr-4">
            {/* <a
            href="https://hero-5.gitbook.io/hero-paper"
            target="_blank"
            className="mx-3 2xl:block hidden text-hero-blue-500 text-[17px] font-medium "
          >
            White paper
          </a> */}

            <div
              className="relative h-[30px] md:h-[40px] xl:h-[50px]  gap-1  flex"
              ref={dropdownRef}
            >
              {/* Button */}
              <div className="box rounded-full relative overflow-hidden inline-block">
                <button
                  className="flex  justify-center  items-center gap-2 bg-gradient-to-tr from-[#9647FF12] to-[#51F19112] rounded-[100px] text-[14px] font-medium py-1 md:py-[0.5rem] xl:py-3 px-1 md:px-4 "
                  onClick={toggleDropdown}
                >
                  <img
                    className="w-4 h-4"
                    src="/icons/download.svg"
                    alt="Download Icon"
                  />
                  <p className="gradient-text text-center hidden md:block ">
                    Browser
                  </p>
                </button>
              </div>

              <AnimatePresence>
                {dropdownOpen && (
                  <motion.div
                    initial={{ opacity: 0, y: -10, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -10, scale: 0.9 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="absolute z-40 top-[1rem] sm:top-12 right-0 sm:right-3 2xl:right-0 my-2 w-[200px] h-[175px] bg-[#111] rounded-lg shadow-lg mt-[25px]"
                  >
                    <div className="flex flex-col items-center gap-3 mt-4 relative">
                      <div className="absolute -top-7 right-5">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path d="M5.625 2L11.25 8H0L5.625 2Z" fill="#111" />
                        </svg>
                      </div>

                      {/* Windows Button */}
                      <motion.div
                        initial={{ opacity: 0, y: -20, scale: 0.9 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -10, scale: 0.9 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        className="inline-block p-[2px] rounded-full"
                        onClick={toggleDropdown}
                      >
                        <a href="https://updates.hero.io/browser/latest?os=win">
                          <button className="bg-gradient-to-br from-hero-blue-478 to-hero-blue-730 shadow-xl shadow-[#121212]/50 min-w-[150px] flex gap-2 rounded-[100px] items-center text-[10px] md:text-[14px] font-medium py-2 px-6">
                            <img
                              src="/icons/windows-head.png"
                              className="w-3 h-3"
                              alt="Windows Logo"
                            />
                            <p className="text-white text-[12px] whitespace-nowrap font-[500]">
                              For Windows
                            </p>
                          </button>
                        </a>
                      </motion.div>

                      {/* MacOS Button */}
                      <motion.div
                        initial={{ opacity: 0, y: -30, scale: 0.9 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -10, scale: 0.9 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        className="inline-block p-[2px] rounded-full"
                        onClick={toggleDropdown}
                      >
                        <a href="https://updates.hero.io/browser/latest?os=mac">
                          <button className="bg-gradient-to-br from-hero-blue-478 to-hero-blue-730 min-w-[150px] shadow-xl shadow-[#121212]/50 flex gap-2 rounded-[100px] items-center text-[10px] md:text-[14px] font-medium py-2 px-6">
                            <img
                              src="/icons/mac-head.svg"
                              className="w-3 h-3"
                              alt="Apple Logo"
                            />
                            <p className="text-white text-[12px] whitespace-nowrap">
                              For MacOS
                            </p>
                          </button>
                        </a>
                      </motion.div>
                      <motion.div
                        initial={{ opacity: 0, y: -30, scale: 0.9 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -10, scale: 0.9 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        className="inline-block p-[2px] rounded-full"
                        onClick={toggleDropdown}
                      >
                        <a href="/private-browser/linux">
                          <button className="bg-gradient-to-br from-hero-blue-478 to-hero-blue-730 min-w-[150px] shadow-xl shadow-[#121212]/50 flex gap-2 rounded-[100px] items-center text-[10px] md:text-[14px] font-medium py-2 px-6">
                            <LinuxIcon />
                            <p className="text-white text-[12px] whitespace-nowrap">
                              For Linux{" "}
                            </p>
                          </button>
                        </a>
                      </motion.div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <Link
              className="hidden xl:flex"
              href="https://wallet.hero.io"
              target="_blank"
            >
              <HeroButton>Wallet</HeroButton>
            </Link>
          </div>

          <div className="hidden">
            {deviceOS === "android" ? (
              <div className="block xl:hidden mr-5">
                <div className="box rounded-full relative overflow-hidden inline-block">
                  <button className="flex justify-center items-center gap-2 bg-gradient-to-tr from-[#9647FF12] to-[#51F19112] rounded-[100px] text-[14px] font-medium py-2 px-4 ">
                    <img src="/icons/download.svg" alt="Download Icon" />
                    <Link
                      href="https://play.google.com/store/apps/details?id=hero.app.main&hl=en"
                      rel="nofollow"
                      target="_blank"
                    >
                      <p className="gradient-text text-center">Android</p>
                    </Link>
                  </button>
                </div>
              </div>
            ) : deviceOS === "ios" ? (
              <div className="hidden">
                <div className="box rounded-full relative overflow-hidden inline-block">
                  <button className="flex justify-center items-center gap-2 bg-gradient-to-tr from-[#9647FF12] to-[#51F19112] rounded-[100px] text-[14px] font-medium py-2 px-4 ">
                    <img src="/icons/download.svg" alt="Download Icon" />
                    <Link href="" rel="nofollow" target="_blank">
                      <p className="gradient-text text-center">iOS</p>
                    </Link>
                  </button>
                </div>
              </div>
            ) : null}
          </div>

          <div className="block xl:hidden">
            <button
              onClick={() => toggleOffcanvas(true)}
              className="outline-none border-none"
              aria-label="Toggle offcanvas menu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8 14H15C15.552 14 16 13.552 16 13C16 12.448 15.552 12 15 12H8C7.448 12 7 12.448 7 13C7 13.552 7.448 14 8 14Z"
                  fill="white"
                />
                <path
                  d="M1 4H15C15.552 4 16 3.552 16 3C16 2.448 15.552 2 15 2H1C0.448 2 0 2.448 0 3C0 3.552 0.448 4 1 4Z"
                  fill="white"
                />
                <path
                  d="M1 9H15C15.552 9 16 8.552 16 8C16 7.448 15.552 7 15 7H1C0.448 7 0 7.448 0 8C0 8.552 0.448 9 1 9Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>

          <div className="relative prt-portfolio">
            <div
              className={`p-3.5 rounded-full font-bold cursor-pointer ${
                isLoggedIn ? "bg-[#3B82F6]" : "bg-gray-600"
              } ml-2`}
              onClick={handleUserClick}
            >
              <UserIcon className="w-5 h-5" />
            </div>

            {showLoginBox && isLoggedIn && (
              <motion.div
                initial={{ opacity: 0, y: -10, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -10, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute z-40 top-[40px] right-1 2xl:right-0 my-2 w-[250px] h-auto p-5 bg-[#666] rounded-lg shadow-lg mt-[25px]"
              >
                <div className="absolute -top-[13px] right-3">
                  <svg width="20" height="20" viewBox="0 0 12 12" fill="none">
                    <path d="M5.625 2L11.25 8H0L5.625 2Z" fill="#666"></path>
                  </svg>
                </div>
                <div className="text-center">
                  <span className="text-white">{decodedToken?.user.email}</span>
                  <button
                    className="w-[80%] mx-auto mt-3 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-full py-2 px-4 hover:from-red-600 hover:to-red-700 transition-all duration-300"
                    onClick={() => {
                      Cookies.remove("token");
                      setIsLoggedIn(false);
                      setShowLoginBox(false);
                    }}
                  >
                    Logout
                  </button>
                </div>
              </motion.div>
            )}
          </div>
        </header>
        {/* {showIframe && <AiIframe onCancel={handleIframe}/>} */}
      </div>
      <IframeComponent />
    </>
  );
};

export default Header;
